export function getImpratioFormat(user) {
  const v = user && user.settings ? user.settings.impression_rate_default_format : null;
  // Default to the legacy/main format when the setting is missing.
  if (!v) return "impression_ratio";
  return v === "ctr" ? "ctr" : "impression_ratio";
}

export function getImpratioLabel(user) {
  return getImpratioFormat(user) === "impression_ratio" ? "Impression Ratio" : "CTR Goal";
}

